import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import { FONT_FAMILY_COMBINATIONS } from './constants';

import sharedStyles from '../_sharedStyles.module.scss';
import componentStyles from './FontFamilyCombinations.module.scss';

const FontFamilyCombinations = ({ setThemeSettings, themeSettings }) => {
  // TODO: Determine if snakecase or camelcase is best.
  const {
    font_family_header: fontFamilyHeader,
    font_family_paragraph: fontFamilyParagraph,
  } = themeSettings;

  const isActiveCombination = useMemo(
    () => (combination) => {
      const fontFamilyCombination = FONT_FAMILY_COMBINATIONS[combination];

      return (
        fontFamilyHeader === fontFamilyCombination.font_family_header &&
        fontFamilyParagraph === fontFamilyCombination.font_family_paragraph
      );
    },
    [fontFamilyHeader, fontFamilyParagraph]
  );

  const handleChange = (event) => {
    const { value: fontFamilyCombination } = event.target;

    setThemeSettings((prevThemeSettings) => ({
      ...prevThemeSettings,
      ...FONT_FAMILY_COMBINATIONS[fontFamilyCombination],
    }));
  };

  const renderFontFamilyCombination = (fontFamilyCombination) => (
    <div key={fontFamilyCombination}>
      <input
        checked={isActiveCombination(fontFamilyCombination)}
        id={fontFamilyCombination}
        onChange={handleChange}
        type="radio"
        value={fontFamilyCombination}
      />

      <label className={componentStyles.pill} htmlFor={fontFamilyCombination}>
        <h3
          className={componentStyles.title}
          style={{
            fontFamily:
              FONT_FAMILY_COMBINATIONS[fontFamilyCombination].font_family_header,
          }}
        >
          Title
        </h3>

        <span
          className={componentStyles.paragraph}
          style={{
            fontFamily:
              FONT_FAMILY_COMBINATIONS[fontFamilyCombination].font_family_paragraph,
          }}
        >
          Paragraph
        </span>
      </label>
    </div>
  );

  return (
    <div className={sharedStyles.form__section}>
      <span className={sharedStyles.form__subtitle}>Fonts</span>

      <div className={componentStyles['pills-container']}>
        {Object.keys(FONT_FAMILY_COMBINATIONS).map(renderFontFamilyCombination)}
      </div>
    </div>
  );
};

FontFamilyCombinations.propTypes = {
  setThemeSettings: PropTypes.func.isRequired,
  themeSettings: PropTypes.shape({
    font_family_header: PropTypes.string.isRequired,
    font_family_paragraph: PropTypes.string.isRequired,
  }).isRequired,
};

export default FontFamilyCombinations;
